import { render } from "./Legend.vue?vue&type=template&id=b51d28e0&scoped=true&ts=true"
import script from "./Legend.vue?vue&type=script&lang=ts"
export * from "./Legend.vue?vue&type=script&lang=ts"

import "./legend.scss?vue&type=style&index=0&id=b51d28e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51d28e0"]])

export default __exports__